<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'CONTROL-TEAM.ADD' | translate}}</h2>

    <div class="col-xs-12">

        <div [hidden]="submitted">
            <form (ngSubmit)="onSubmit()" #controlTeamForm="ngForm">
                <button type="submit" class="btn btn-primary" style="float: right;" [disabled]="!controlTeamForm.form.valid">{{'FUNCTION-BUTTONS.SAVE' | translate}}
        </button>
                <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">{{'FUNCTION-BUTTONS.CANCEL' | translate}}</button>

                <br/>
                <br/><br/>
                <div class="form-group">
                    <label for="name">{{'CONTROL-TEAM.NAME' | translate}}</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="controlTeam.name" name="name" #name="ngModel" required>
                    <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
                        {{'CONTROL-TEAM.NAME_REQUIRED' | translate}}
                    </div>
                </div>

                <div class="form-group">
                    <label for="description">{{'CONTROL-TEAM.DESCRIPTION' | translate}}</label>
                    <input type="text" class="form-control" id="description" [(ngModel)]="controlTeam.description" name="description" #description="ngModel">
                </div>

                <div class="form-group" style="margin-top: 10px;">
                    <label for="controllers">{{'CONTROL-TEAM.CONTROLLERS' | translate}}</label>
                    <ntr-multiple-select #controllersListSelect [items]="controllers" [key]="'username'"
                    [placeholder]="'Controller(s)'"
                    [display]="'username'" [activeItems]="controlTeam.controllers"></ntr-multiple-select>
                </div>

            </form>
        </div>
    </div>
</div>